<div class="badge-type-modal-backdrop" (click)="onClose()"></div>
<div class="badge-type-modal">
  <div class="modal-header">
    <h3>Badge options</h3>
    <button class="close-icon-btn" (click)="onClose()" aria-label="Close">&times;</button>
  </div>
  <div class="modal-subtitle">
    Select an actions below
  </div>
  <div class="modal-body" *ngIf="categoryId !== 9">
    <button class="badge-option-btn"
            [class.selected]="selected==='initial'"
            (click)="onSelect('initial')"
            (mouseenter)="onHover('initial')">
      <span [class.active]="selected==='initial'">
        <img src="assets/icons/user-icons.png" alt="" class="badge-icon" />
        New badge request
      </span>
    </button>
    <button class="badge-option-btn"
            [class.selected]="selected==='extension'"
            (click)="onSelect('extension')"
            (mouseenter)="onHover('extension')">
      <span [class.active]="selected==='extension'">
        <img src="assets/icons/extension-icons.png" alt="" class="badge-icon" />
        Badge Validity extension
      </span>
    </button>
  </div>
  <div class="modal-body" *ngIf="categoryId === 9">
    <button class="badge-option-btn"
            [class.selected]="selected==='mdf-new'"
            (click)="onSelect('mdf-new')"
            (mouseenter)="onHover('mdf-new')">
      <span [class.active]="selected==='mdf-new'">
        <img src="assets/icons/user-icons.png" alt="" class="badge-icon" />
        MDF Work permit – New badge
      </span>
    </button>
    <button class="badge-option-btn"
            [class.selected]="selected==='mdf-access'"
            (click)="onSelect('mdf-access')"
            (mouseenter)="onHover('mdf-access')">
      <span [class.active]="selected==='mdf-access'">
        <img src="assets/icons/extension-icons.png" alt="" class="badge-icon" />
        MDF Work permit – Access only
      </span>
    </button>
  </div>
  <div class="modal-footer">
    <button class="close-btn" (click)="onClose()">Close</button>
  </div>
</div>